// src/components/BtnCopyUrl.tsx
import { WEB_URL } from '../config'

import { useCopyToClipboard } from 'react-use'

function BtnCopyUrl() {
  const [state, copyToClipboard] = useCopyToClipboard()

  const onCopy = () => copyToClipboard(WEB_URL)

  return (
    <>
      <div style={{ height: 23 }} />
      <button
        type="button"
        style={{
          outline: 'none',
          border: 'none',
          backgroundColor: '#fff',
          color: '#333',
          padding: 20,
          borderRadius: 10,
          fontSize: 'large',
        }}
        onClick={onCopy}
      >
        Please click here to copy app url.
      </button>
      <div style={{ height: 20, marginTop: 10 }}>
        {state.error ? (
          <span style={{ color: '#f00' }}>
            something went wrong: {state.error.message}
          </span>
        ) : (
          state.value && (
            <span style={{ color: '#0f0' }}>Copied!</span>
          )
        )}
      </div>
    </>
  )
}

export default BtnCopyUrl
